import { ClipboardCheckIcon, FolderOpenIcon, SigmaIcon, TargetIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Renewable Energy Classroom Activities',
    description:
      '150 ready-to-use activity ideas covering solar, wind, hydropower, biomass, storage, energy efficiency, and the energy transition. Organized by difficulty level.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: '100 Solved Problems, Calculations & Exercises',
    description:
      'Progressive exercises on power, energy, consumption, generation, efficiency, solar panel sizing, battery calculations, autonomy, wind, and hydropower. Each with complete step-by-step solutions.',
    benefit: 'Your students learn by seeing how solutions are actually worked.',
    value: 'USD 14',
    icon: SigmaIcon,
  },
  {
    number: '03',
    title: 'Complete Renewable Energy Assessment Suite',
    description:
      'Diagnostic assessments, progress activities, multiple-choice questions, true/false exercises, problem-solving scenarios, integrated assessments, rubrics, and evaluation criteria. All included directly in the PDF.',
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '04',
    title: '50 Renewable Energy Projects & STEM Challenges',
    description:
      '50 educational and technical project ideas with clear objectives, suggested materials, development stages, specific prompts, and evaluation criteria. From introductory to complex integrated projects.',
    benefit: 'Your students finish the year with real projects in their own communities.',
    value: 'USD 14',
    icon: TargetIcon,
  },
  {
    number: '05',
    title: 'Visual Guide to Renewable Energy Technologies & Components',
    description:
      'Reference material on solar panels, inverters, controllers, batteries, wind turbines, hydro turbines, and biodigesters. Includes explanatory diagrams, comparison tables, key concepts, and operation principles.',
    benefit: 'Project it in class and your students instantly understand how each component works.',
    value: 'USD 14',
    icon: ZapIcon,
    wide: true,
  },
];
